import {
  createClientDropdown,
  createGroupTypeDropdown,
  HEALTH_PLAN_DROPDOWN,
  PLAN_TYPE_DROPDOWN,
  sortFilterDropdowns,
} from 'constants/filterConfigs';
import {
  END_DATE,
  HEALTH_PLAN_CLASSIFICATION,
  PLAN_TYPE_CLASSIFICATION,
  SENDING_GROUP,
  START_DATE,
} from 'constants/filterKeysConstants';
import GroupType from 'models/GroupType';
import { ReferralsInsightsFilterState } from 'stores/referralsInsightsStore';

// Receiving group type filter keys use the group type's camelCaseApiName,
// matching the Insights pattern (e.g., homeHealth, homeHealthClient).
export const receivingGroupFilterKey = (groupType: GroupType) => groupType.camelCaseApiName;
export const receivingClientFilterKey = (groupType: GroupType) => `${groupType.camelCaseApiName}Client`;

const filterKeysForSelectedGroupType = (selectedGroupType: GroupType): string[] => {
  return [
    SENDING_GROUP,
    receivingClientFilterKey(selectedGroupType),
    receivingGroupFilterKey(selectedGroupType),
    HEALTH_PLAN_CLASSIFICATION,
    PLAN_TYPE_CLASSIFICATION,
    START_DATE,
    END_DATE,
  ];
};

export const filtersForSelectedGroupType = (
  filters: ReferralsInsightsFilterState,
  selectedGroupType: GroupType
): ReferralsInsightsFilterState => {
  const validKeys = filterKeysForSelectedGroupType(selectedGroupType);
  return Object.entries(filters).reduce(
    (acc, [key, val]) => (validKeys.includes(key) ? { ...acc, [key]: val } : acc),
    {} as ReferralsInsightsFilterState
  );
};

export const getReferralFilterSections = (
  sendingGroupType: GroupType | undefined,
  selectedGroupType: GroupType | undefined
) => {
  if (!sendingGroupType || !selectedGroupType) return [];

  const receivingGroupTypeName = selectedGroupType.displayName;

  const sendingGroupDropdown = createGroupTypeDropdown(sendingGroupType, undefined, {
    placeholder: `Referring ${sendingGroupType.displayName}`,
    name: SENDING_GROUP,
  });

  const receivingClientDropdown = createClientDropdown(
    [selectedGroupType.id],
    `${receivingGroupTypeName} Company`,
    receivingClientFilterKey(selectedGroupType),
    { groupTypeType: 'provider' }
  );

  const receivingGroupDropdown = createGroupTypeDropdown(selectedGroupType, undefined, {
    placeholder: receivingGroupTypeName,
    name: receivingGroupFilterKey(selectedGroupType),
  });

  return [
    {
      filters: sortFilterDropdowns([
        sendingGroupDropdown,
        receivingClientDropdown,
        receivingGroupDropdown,
        HEALTH_PLAN_DROPDOWN,
        PLAN_TYPE_DROPDOWN,
      ]),
    },
  ];
};
